import { Element } from "react-scroll";

import React from "react";
import SectionOne from "./views/SectionOne";
import QuienesSomos from "./views/QuienesSomos";
import NuestrosServicios from "./views/NuestrosServicios";
import Opiniones from "./views/Opiniones";
import FormOpinion from "./views/FormOpinion";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Solicitar from "./views/Solicitar";
import Contactanos from "./views/Contactanos";

function App() {
	return (
		<div className="pt-16">
			<Header />
			<Element name="inicio">
				<SectionOne />
			</Element>
			<QuienesSomos />
			<Element name="servicios">
				<NuestrosServicios />
			</Element>
				<FormOpinion />
			<Opiniones />
			<Element name="solicitar">
				<Solicitar />
			</Element>
			<Element name="contactanos">
			<Contactanos />
			</Element>
			<Footer />
		</div>
	);
}

export default App;
